import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';

function AuthGuard({ children }) {
  const { enqueueSnackbar } = useSnackbar();
  const account = useSelector((state) => state.account);
  const { patient, hearingDeviceSettingLeft } = useSelector((state) => state.patient);

  const location = useLocation();
  const path = location.pathname;

  // if (path.startsWith("/app/fitting")) {
  //   if (!hearingDeviceSettingLeft && !hearingDeviceSettingLeft) {
  //     enqueueSnackbar("请先选择助听器", {
  //       variant: "error"
  //     });
  //     return <Redirect to="/app/devices/hearingInstrument" />;
  //   }
  // }
  if (!account.user) {
    return <Redirect to="/login" />;
  }

  // if (!patient)
  //   return <Redirect to="/select" />;

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
